'use strict';

import { loggedInUserDataStore } from "../modules/shared/stores/loggedInUserDataStore";
import { solutionsStore } from "../modules/shared/stores/solutionsStore";
import { getEnabledModules, getAvailableModules } from "../modules/shared/utils/paidModulesUtils";


angular.module('app').factory('InitUtil', InitUtil);

InitUtil.$inject = ['PaymentService', 'localStorageService', 'constants', 'utilService', '$rootScope', 'CoachService', 'EntityService', 'SolutionsService'];

function InitUtil(PaymentService, localStorageService, constants, utilService, $rootScope, CoachService, EntityService, SolutionsService) {
  const storageKeys = constants.enums.storageKeys;
  const eventKeys = constants.enums.eventKeys;
  const solutionType  = constants.enums.solutionType;
  const { AGENT, ADMIN, SUPERUSER } = constants.enums.userRoles;

  return {
    initGeneralAppLogic() {
      const loggedInUser = utilService.getLoggedInUserData();
      // it is not run for super admin because his gym id is 0
      if (loggedInUser?.gymId) {
        return this.initForGeneralUser(loggedInUser);
      }

      if (loggedInUser?.role === SUPERUSER) {
        return this.setSolutionsForSuperAdmin();
      }
    },
    /** @private */
    initForGeneralUser(loggedInUser) {
      return Promise.all([
        this.setSystemPaymentInfo(loggedInUser.gymId),
        this.setEnabledModules(loggedInUser.gymId),
        this.setAvailableModules(loggedInUser.entityType),
        this.setComplianceCoachInfo(loggedInUser),
        this.setIsEntityHasChild(loggedInUser),
        this.setSolutions(loggedInUser.gymId),
      ]).then(() => {
        $rootScope.$broadcast(eventKeys.INIT_USER_INFO_FINISHED);
      });
    },

    setSystemPaymentInfo(entityId) {
      return PaymentService.getSystemPaymentInfo(entityId).then((flagsObject) => {
          localStorageService.set(storageKeys.PAYMENT_FLOW_TYPE, flagsObject.paymentFlowTypeFlags);
          localStorageService.set(storageKeys.BILLING_TYPE, flagsObject.billingTypeFlags);
          this.loggedInUserDataStore.setPaymentFlowType(flagsObject.paymentFlowTypeFlags);
          this.loggedInUserDataStore.setBillingType(flagsObject.billingTypeFlags);
         }
       );
    },

    setEnabledModules(entityId) {
      return getEnabledModules(entityId).then(enabledModules => {
        localStorageService.set(storageKeys.ENABLED_MODULES, enabledModules);
        this.loggedInUserDataStore.setEnabledModules(enabledModules);
      });
    },

    setAvailableModules(entityType) {
      return getAvailableModules(entityType).then(availableModules => {
        localStorageService.set(storageKeys.AVAILABLE_MODULES, availableModules);
        this.loggedInUserDataStore.setAvailableModules(availableModules);
      });
    },

    setComplianceCoachInfo(loggedInUser) {
      if (loggedInUser.role !== AGENT) {
        return;
      }

      return CoachService.getCoachAccountSettings(loggedInUser.id).then((res) => {
        if (res.status === 200) {
          const complianceCoach = res.data.additional.complianceCoach;

          localStorage.setItem(storageKeys.COMPLIANCE_COACH, JSON.stringify(complianceCoach));
          this.loggedInUserDataStore.setIsComplianceCoach(complianceCoach);
        }
      });
    },

    setIsEntityHasChild(loggedInUser) {
      if (loggedInUser.role !== ADMIN) {
        return;
      }

      return EntityService.getIsEntityHasChildren(loggedInUser.gymId).then((res) => {
        if (res.status === 200) {
          const isEntityHasChild = res.data;

          localStorageService.set(storageKeys.IS_ENTITY_HAS_CHILD, isEntityHasChild);
          this.loggedInUserDataStore.setIsEntityHasChild(isEntityHasChild);
        }
      });
    },

    setSolutions(entityId) {
      return SolutionsService.getSolutions(entityId).then((res) => {
        if (res.status === 200) {
          localStorageService.set(storageKeys.SOLUTION_TYPE_FLAGS, res.data.solutionTypeFlags);
          this.solutionsStore.setSolutionsInfo({
            solutions: res.data.solutions,
            solutionTypeFlags: res.data.solutionTypeFlags,
          });
        }
      });
    },
    setSolutionsForSuperAdmin() {
      const solutions = {
        solutionTypeFlags: {
          [solutionType.NUTRITION]: true,
          [solutionType.SCAN_IQ]: true,
          [solutionType.CHALLENGE]: true,
        },
        solutions: [solutionType.NUTRITION, solutionType.SCAN_IQ, solutionType.CHALLENGE],
      };

      localStorageService.set(storageKeys.SOLUTION_TYPE_FLAGS, solutions.solutionTypeFlags);
      this.solutionsStore.setSolutionsInfo(solutions);
    },
    loggedInUserDataStore: loggedInUserDataStore,
    solutionsStore: solutionsStore,
  }
}
